import { Sender } from 'xstate';

import config from '@/config';
import asyncCallback from '@/framework/logic/utils/asyncCallback';
import { LogicContext } from '@/logic/main/types';

export const watchRecentlyPlayedTimer = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'RECENTLY_PLAYED_TO_UPDATE';
      }>
    ) => {
      let timeoutToken: ReturnType<typeof setTimeout>;
      timeoutToken = setTimeout(() => {
        callback({
          type: 'RECENTLY_PLAYED_TO_UPDATE',
        });
      }, config.intervals.recentlyPlayedGamesCheck);

      return () => {
        clearTimeout(timeoutToken);
      };
    }
  );
